import {SchoolInterface} from "../db/models/school";

export const getSchoolDiversity = (school: SchoolInterface) => {
    const diversity = school.diversity.studentReferralCount;
    const total = school.studentReferralCount || 0;
    return {total, partial: diversity["2"]};
}

export const getSchoolDiversityPercentage = (school: SchoolInterface): number => {
    if (!school) return 0;

    const diversity = school.diversity?.studentReferralCount;
    const partial = diversity?.["2"] || 0;
    const total = school.studentReferralCount || 0;

    if (partial === 0) return 0;
    else
        return Math.round(partial / total * 100);
}